{
  "PROFILE_SETTINGS": {
    "LINK": "ตั้งค่าข้อมูลส่วนตัว",
    "TITLE": "ตั้งค่าข้อมูลส่วนตัว",
    "BTN_TEXT": "อัปเดตข้อมูลส่วนตัว",
    "DELETE_AVATAR": "ลบรูป",
    "AVATAR_DELETE_SUCCESS": "ลบรูปสำเร็จแล้ว",
    "AVATAR_DELETE_FAILED": "เกิดข้อผิดพลาดขณะลบรูป โปรดลองใหม่อีกครั้ง",
    "UPDATE_SUCCESS": "ข้อมูลส่วนตัวของคุณได้รับการอัปเดตแล้ว",
    "PASSWORD_UPDATE_SUCCESS": "เปลี่ยนรหัสผ่านของคุณเรียบร้อยแล้ว",
    "AFTER_EMAIL_CHANGED": "ข้อมูลส่วนตัวของคุณได้รับการอัปเดตแล้ว โปรดเข้าสู่ระบบใหม่อีกครั้งเนื่องจากมีการเปลี่ยนแปลงข้อมูลสำหรับยืนยันตัวตน",
    "FORM": {
      "PICTURE": "Profile Picture",
      "AVATAR": "รูปโปรไฟล์",
      "ERROR": "กรุณาเเก้ไขข้อผิดพลาดในเเบบฟอร์ม",
      "REMOVE_IMAGE": "ลบรูปภาพ",
      "UPLOAD_IMAGE": "อัปโหลดรูปภาพ",
      "UPDATE_IMAGE": "อัปเดตรูปภาพ",
      "PROFILE_SECTION": {
        "TITLE": "ข้อมูลส่วนตัว",
        "NOTE": "อีเมลเป็นข้อมูลระบุตัวตนของคุณ และใช้ในการเข้าสู่ระบบ"
      },
      "SEND_MESSAGE": {
        "TITLE": "Hotkey to send messages",
        "NOTE": "You can select a hotkey (either Enter or Cmd/Ctrl+Enter) based on your preference of writing.",
        "UPDATE_SUCCESS": "Your settings have been updated successfully",
        "CARD": {
          "ENTER_KEY": {
            "HEADING": "Enter (↵)",
            "CONTENT": "Send messages by pressing Enter key instead of clicking the send button."
          },
          "CMD_ENTER_KEY": {
            "HEADING": "Cmd/Ctrl + Enter (⌘ + ↵)",
            "CONTENT": "Send messages by pressing Cmd/Ctrl + enter key instead of clicking the send button."
          }
        }
      },
      "INTERFACE_SECTION": {
        "TITLE": "Interface",
        "NOTE": "Customize the look and feel of your Chatwoot dashboard.",
        "FONT_SIZE": {
          "TITLE": "Font size",
          "NOTE": "Adjust the text size across the dashboard based on your preference.",
          "UPDATE_SUCCESS": "Your font settings have been updated successfully",
          "UPDATE_ERROR": "There is an error while updating the font settings, please try again",
          "OPTIONS": {
            "SMALLER": "Smaller",
            "SMALL": "Small",
            "DEFAULT": "Default",
            "LARGE": "Large",
            "LARGER": "Larger",
            "EXTRA_LARGE": "Extra Large"
          }
        },
        "LANGUAGE": {
          "TITLE": "Preferred Language",
          "NOTE": "Choose the language you want to use.",
          "UPDATE_SUCCESS": "Your Language settings have been updated successfully",
          "UPDATE_ERROR": "There is an error while updating the language settings, please try again",
          "USE_ACCOUNT_DEFAULT": "Use account default"
        }
      },
      "MESSAGE_SIGNATURE_SECTION": {
        "TITLE": "ลายเซ็นส่วนตัว",
        "NOTE": "Create a unique message signature to appear at the end of every message you send from any inbox. You can also include an inline image, which is supported in live-chat, email, and API inboxes.",
        "BTN_TEXT": "บันทึกลายเซ็น",
        "API_ERROR": "ไม่สามารถบันทึกลายเซ็นได้ โปรดลองใหม่อีกครั้ง",
        "API_SUCCESS": "บันทึกลายเซ็นสำเร็จแล้ว",
        "IMAGE_UPLOAD_ERROR": "Couldn't upload image! Try again",
        "IMAGE_UPLOAD_SUCCESS": "Image added successfully. Please click on save to save the signature",
        "IMAGE_UPLOAD_SIZE_ERROR": "Image size should be less than {size}MB",
        "INLINE_IMAGE_WARNING": "Pasted inline images were removed. Please use the image upload button to add images to your signature."
      },
      "MESSAGE_SIGNATURE": {
        "LABEL": "ข้อความลายเซ็น",
        "ERROR": "ข้อความลายเซ็นไม่สามารถเว้นว่างได้",
        "PLACEHOLDER": "ใส่ข้อความที่คุณต้องการใช้เป็นลายเซ็นที่นี่"
      },
      "PASSWORD_SECTION": {
        "TITLE": "หรัสผ่าน",
        "NOTE": "การอัปเดตรหัสผ่านจะรีเซ็ทการเข้าสู่ระบบของบัญชีนี้ในอุปกรณ์อื่นๆ",
        "BTN_TEXT": "เปลี่ยนรหัสผ่าน"
      },
      "SECURITY_SECTION": {
        "TITLE": "Security",
        "NOTE": "Manage additional security features for your account.",
        "MFA_BUTTON": "Manage Two-Factor Authentication"
      },
      "SESSIONS_SECTION": {
        "TITLE": "Active Sessions",
        "NOTE": "These are the devices currently logged in to your account.",
        "CURRENT": "Current session",
        "REVOKE": "Revoke",
        "REVOKE_SUCCESS": "Session revoked successfully",
        "REVOKE_ERROR": "Unable to revoke session. Please try again.",
        "FETCH_ERROR": "Unable to fetch sessions. Please try again.",
        "LAST_ACTIVE": "Last active",
        "UNKNOWN_DEVICE": "Unknown device"
      },
      "ACCESS_TOKEN": {
        "TITLE": "Access Token",
        "NOTE": "คุณสามารถใช้ token นี้เชื่อมต่อกับ API ได้",
        "PAID_PLAN_NOTE": "API access tokens are available on paid plans.",
        "COPY": "คัดลอก",
        "RESET": "Reset",
        "CONFIRM_RESET": "Are you sure?",
        "CONFIRM_HINT": "Click again to confirm",
        "RESET_SUCCESS": "Access token regenerated successfully",
        "RESET_ERROR": "Unable to regenerate access token. Please try again"
      },
      "AUDIO_NOTIFICATIONS_SECTION": {
        "TITLE": "Audio Alerts",
        "NOTE": "Enable audio alerts in dashboard for new messages and conversations.",
        "PLAY": "Play sound",
        "ALERT_TYPES": {
          "NONE": "ไม่มี",
          "MINE": "Assigned",
          "ALL": "ทั้งหมด",
          "ASSIGNED": "My assigned conversations",
          "UNASSIGNED": "Unassigned conversations",
          "NOTME": "Open conversations assigned to others"
        },
        "ALERT_COMBINATIONS": {
          "NONE": "You haven't selected any options, you won't receive any audio alerts.",
          "ASSIGNED": "You'll receive alerts for conversations assigned to you.",
          "UNASSIGNED": "You'll receive alerts for any unassigned conversations.",
          "NOTME": "You'll receive alerts for conversations assigned to others.",
          "ASSIGNED+UNASSIGNED": "You'll receive alerts for your assigned conversations and any unattended ones.",
          "ASSIGNED+NOTME": "You'll receive alerts for conversations assigned to you and to others, but not for unassigned ones.",
          "NOTME+UNASSIGNED": "You'll receive alerts for unattended conversations and those assigned to others.",
          "ASSIGNED+NOTME+UNASSIGNED": "You'll receive alerts for all conversations."
        },
        "ALERT_TYPE": {
          "TITLE": "Alert events for conversations",
          "NONE": "ไม่มี",
          "ASSIGNED": "การสนทนาที่ได้รับมอบหมาย",
          "ALL_CONVERSATIONS": "การสนทนาทั้งหมด"
        },
        "DEFAULT_TONE": {
          "TITLE": "Alert tone:"
        },
        "CONDITIONS": {
          "TITLE": "Alert conditions:",
          "CONDITION_ONE": "Send audio alerts only if the browser window is not active",
          "CONDITION_TWO": "Send alerts every 30s until all the assigned conversations are read"
        },
        "SOUND_PERMISSION_ERROR": "Autoplay is disabled in your browser. To hear alerts automatically, enable sound permission in your browser settings or interact with the page.",
        "READ_MORE": "Read more"
      },
      "EMAIL_NOTIFICATIONS_SECTION": {
        "TITLE": "การแจ้งเตือนทางอีเมล",
        "NOTE": "ตั้งค่าการแจ้งเตือนทางอีเมลของคุณที่นี่",
        "CONVERSATION_ASSIGNMENT": "ส่งอีเมลแจ้งเตือนเมื่อมีบทสนทนาที่ฉันได้รับมอบหมาย",
        "CONVERSATION_CREATION": "ส่งอีเมลแจ้งเตือนเมื่อมีการสร้างบทสนทนาใหม่",
        "CONVERSATION_MENTION": "ส่งอีเมลแจ้งเตือนเมื่อฉันถูกกล่าวถึงในการสนทนา",
        "ASSIGNED_CONVERSATION_NEW_MESSAGE": "ส่งอีเมลแจ้งเตือนเมื่อมีข้อความใหม่ในการสนทนาที่ฉันได้รับมอบหมาย",
        "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Send email notifications when a new message is created in a participating conversation",
        "SLA_MISSED_FIRST_RESPONSE": "Send email notifications when a conversation misses first response SLA",
        "SLA_MISSED_NEXT_RESPONSE": "Send email notifications when a conversation misses next response SLA",
        "SLA_MISSED_RESOLUTION": "Send email notifications when a conversation misses resolution SLA"
      },
      "NOTIFICATIONS": {
        "TITLE": "Notification preferences",
        "TYPE_TITLE": "Notification type",
        "EMAIL": "อีเมล์",
        "PUSH": "Push notification",
        "TYPES": {
          "CONVERSATION_CREATED": "A new conversation is created",
          "CONVERSATION_ASSIGNED": "A conversation is assigned to you",
          "CONVERSATION_MENTION": "You are mentioned in a conversation",
          "ASSIGNED_CONVERSATION_NEW_MESSAGE": "A new message is created in an assigned conversation",
          "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "A new message is created in a participating conversation",
          "SLA_MISSED_FIRST_RESPONSE": "A conversation misses first response SLA",
          "SLA_MISSED_NEXT_RESPONSE": "A conversation misses next response SLA",
          "SLA_MISSED_RESOLUTION": "A conversation misses resolution SLA"
        },
        "BROWSER_PERMISSION": "Enable push notifications for your browser so you’re able to receive them"
      },
      "API": {
        "UPDATE_SUCCESS": "ปรับแต่งการแจ้งเตือนสำเร็จแล้ว",
        "UPDATE_ERROR": "เกิดข้อผิดพลาดขณะอัปเดต โปรดลองใหม่อีกครั้ง"
      },
      "PUSH_NOTIFICATIONS_SECTION": {
        "TITLE": "การแจ้งเตือนแบบพุช",
        "NOTE": "ตั้งค่าการแจ้งเตือนแบบพุชที่นี่",
        "CONVERSATION_ASSIGNMENT": "ส่งการแจ้งเตือนแบบพุชเมื่อมีการสนทนาที่ฉันได้รับมอบหมาย",
        "CONVERSATION_CREATION": "ส่งการแจ้งเตือนแบบพุชเมื่อมีการสนทนาใหม่",
        "CONVERSATION_MENTION": "ส่งการแจ้งเตือนแบบพุชเมื่อฉันถูกกล่าวถึงในการสนทนา",
        "ASSIGNED_CONVERSATION_NEW_MESSAGE": "ส่งการแจ้งเตือนแบบพุชเมื่อมีข้อความใหม่ในการสนทนาที่ฉันได้รับมอบหมาย",
        "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Send push notifications when a new message is created in a participating conversation",
        "HAS_ENABLED_PUSH": "คุณได้เปิดการแจ้งเตือนแบบพุชสำหรับเบราว์เซอร์นี้",
        "REQUEST_PUSH": "เปิดการแจ้งเตือนแบบพุช",
        "SLA_MISSED_FIRST_RESPONSE": "Send push notifications when a conversation misses first response SLA",
        "SLA_MISSED_NEXT_RESPONSE": "Send push notifications when a conversation misses next response SLA",
        "SLA_MISSED_RESOLUTION": "Send push notifications when a conversation misses resolution SLA"
      },
      "PROFILE_IMAGE": {
        "LABEL": "รูปโปรไฟล์"
      },
      "NAME": {
        "LABEL": "ชื่อเต็ม",
        "ERROR": "โปรดใส่ชื่อเต็มที่ถูกต้อง",
        "PLACEHOLDER": "โปรดใส่ชื่อเต็มของคุณ"
      },
      "DISPLAY_NAME": {
        "LABEL": "ชื่อที่ใช้แสดง",
        "ERROR": "โปรดใส่ชื่อที่ใช้แสดงให้ถูกต้อง",
        "PLACEHOLDER": "โปรดใส่ชื่อที่คุณต้องการใช้แสดงในการสนทนา"
      },
      "AVAILABILITY": {
        "LABEL": "สถานะ",
        "STATUS": {
          "ONLINE": "ออนไลน์",
          "BUSY": "ไม่ว่าง",
          "OFFLINE": "ออฟไลน์"
        },
        "SET_AVAILABILITY_SUCCESS": "Availability has been set successfully",
        "SET_AVAILABILITY_ERROR": "Couldn't set availability, please try again",
        "IMPERSONATING_ERROR": "Cannot change availability while impersonating a user"
      },
      "EMAIL": {
        "LABEL": "อีเมลของคุณ",
        "ERROR": "กรุณากรอกที่อยู่อีเมล์ให้ถูกต้อง",
        "PLACEHOLDER": "โปรดกรอกอีเมลของคุณ อีเมลจะถูกแสดงขณะสนทนา"
      },
      "CURRENT_PASSWORD": {
        "LABEL": "รหัสผ่านปัจจุบัน",
        "ERROR": "โปรดใส่รหัสผ่านปัจจุบัน",
        "PLACEHOLDER": "โปรดใส่รหัสผ่านปัจจุบัน"
      },
      "PASSWORD": {
        "LABEL": "รหัสผ่านใหม่",
        "ERROR": "โปรดใส่รหัสผ่านที่มีอย่างน้อย 6 ตัวอักษร",
        "PLACEHOLDER": "โปรดใส่รหัสผ่านใหม่"
      },
      "PASSWORD_CONFIRMATION": {
        "LABEL": "ยืนยันรหัสผ่านใหม่",
        "ERROR": "รหัสผ่านไม่ตรงกัน",
        "PLACEHOLDER": "โปรดใส่รหัสผ่านใหม่อีกครั้ง"
      }
    }
  },
  "SIDEBAR_ITEMS": {
    "CHANGE_AVAILABILITY_STATUS": "เปลี่ยน",
    "CHANGE_ACCOUNTS": "Switch account",
    "SWITCH_ACCOUNT": "Switch account",
    "CONTACT_SUPPORT": "Contact support",
    "SELECTOR_SUBTITLE": "เลือกบัญชีจากรายชื่อต่อไปนี้",
    "PROFILE_SETTINGS": "Profile settings",
    "YEAR_IN_REVIEW": "Year in Review",
    "KEYBOARD_SHORTCUTS": "Keyboard shortcuts",
    "APPEARANCE": "Change appearance",
    "SUPER_ADMIN_CONSOLE": "SuperAdmin console",
    "DOCS": "Read documentation",
    "CHANGELOG": "Changelog",
    "LOGOUT": "Log out"
  },
  "APP_GLOBAL": {
    "TRIAL_MESSAGE": "จำนวนวันทดลองใช้ที่เหลืออยู่",
    "TRAIL_BUTTON": "ซื้อเลย",
    "DELETED_USER": "ผู้ใช้งานที่ถูกลบ",
    "EMAIL_VERIFICATION_PENDING": "It seems that you haven't verified your email address yet. Please check your inbox for the verification email.",
    "RESEND_VERIFICATION_MAIL": "Resend verification email",
    "EMAIL_VERIFICATION_SENT": "Verification email has been sent. Please check your inbox.",
    "ACCOUNT_SUSPENDED": {
      "TITLE": "Account Suspended",
      "MESSAGE": "Your account is suspended. Please reach out to the support team for more information."
    },
    "NO_ACCOUNTS": {
      "TITLE": "No account found",
      "MESSAGE_CLOUD": "You are not part of any accounts right now. If you think this is a mistake, please reach out to our support team.",
      "MESSAGE_SELF_HOSTED": "You are not part of any accounts right now. Please reach out to your administrator.",
      "LOGOUT": "Log out"
    }
  },
  "COMPONENTS": {
    "CODE": {
      "BUTTON_TEXT": "คัดลอก",
      "CODEPEN": "Open in CodePen",
      "COPY_SUCCESSFUL": "คัดลอกไปยังคลิปบอร์ดเเล้ว"
    },
    "SHOW_MORE_BLOCK": {
      "SHOW_MORE": "แสดงเพิ่มเติม",
      "SHOW_LESS": "แสดงน้อยลง"
    },
    "FILE_BUBBLE": {
      "DOWNLOAD": "ดาวโหลด",
      "UPLOADING": "กำลังอัปโหลด",
      "INSTAGRAM_STORY_UNAVAILABLE": "This story is no longer available.",
      "INSTAGRAM_STORY_REPLY": "Replied to your story:"
    },
    "LOCATION_BUBBLE": {
      "SEE_ON_MAP": "See on map"
    },
    "FORM_BUBBLE": {
      "SUBMIT": "ส่ง"
    },
    "MEDIA": {
      "IMAGE_UNAVAILABLE": "This image is no longer available.",
      "LOADING_FAILED": "Loading failed"
    }
  },
  "CONFIRM_EMAIL": "กำลังตรวจสอบ",
  "SETTINGS": {
    "INBOXES": {
      "NEW_INBOX": "เพิ่มกล่องข้อความ"
    }
  },
  "SIDEBAR": {
    "NO_ITEMS": "No items",
    "CURRENTLY_VIEWING_ACCOUNT": "กำลังดูอยู่:",
    "SWITCH": "Switch",
    "INBOX_VIEW": "Inbox View",
    "CONVERSATIONS": "การสนทนา",
    "INBOX": "My Inbox",
    "ALL_CONVERSATIONS": "การสนทนาทั้งหมด",
    "MENTIONED_CONVERSATIONS": "การกล่าวถึง",
    "PARTICIPATING_CONVERSATIONS": "Participating",
    "UNATTENDED_CONVERSATIONS": "ไม่ได้เข้าร่วม",
    "REPORTS": "รายงาน",
    "SETTINGS": "ตั้งค่า",
    "CONTACTS": "ผู้ติดต่อ",
    "ACTIVE": "ใช้งานอยู่",
    "COMPANIES": "Companies",
    "ALL_COMPANIES": "All Companies",
    "CAPTAIN": "Captain",
    "CAPTAIN_ASSISTANTS": "Assistants",
    "CAPTAIN_OVERVIEW": "ภาพรวม",
    "CAPTAIN_DOCUMENTS": "Documents",
    "CAPTAIN_RESPONSES": "FAQs",
    "CAPTAIN_TOOLS": "Tools",
    "CAPTAIN_SCENARIOS": "Scenarios",
    "CAPTAIN_PLAYGROUND": "Playground",
    "CAPTAIN_INBOXES": "กล่องข้อความ",
    "CAPTAIN_SETTINGS": "ตั้งค่า",
    "HOME": "หน้าหลัก",
    "AGENTS": "พนักงาน",
    "AGENT_BOTS": "บอท",
    "AUDIT_LOGS": "Audit Logs",
    "INBOXES": "กล่องข้อความ",
    "NOTIFICATIONS": "การแจ้งเตือน",
    "CANNED_RESPONSES": "คำตอบสำเร็จรูป",
    "INTEGRATIONS": "การเชื่อมต่อกับระบบ",
    "DATA": "Data",
    "PROFILE_SETTINGS": "ตั้งค่าข้อมูลส่วนตัว",
    "ACCOUNT_SETTINGS": "ตั้งค่าบัญชี",
    "APPLICATIONS": "โปรแกรม",
    "LABELS": "ป้ายกำกับ",
    "CUSTOM_ATTRIBUTES": "แอตทริบิวต์ที่กำหนดเอง",
    "AUTOMATION": "เงื่อนไขอัตโนมัติ",
    "MACROS": "Macros",
    "TEAMS": "ทีม",
    "BILLING": "Billing",
    "CUSTOM_VIEWS_FOLDER": "โฟลเดอร์",
    "CUSTOM_VIEWS_SEGMENTS": "กลุ่มตามตัวกรอง",
    "ALL_CONTACTS": "รายชื่อผู้ติดต่อทั้งหมด",
    "TAGGED_WITH": "ที่ติดป้าย",
    "NEW_LABEL": "เพิ่มป้ายกำกับ",
    "NEW_TEAM": "สร้างทีมใหม่",
    "NEW_INBOX": "เพิ่มกล่องข้อความ",
    "REPORTS_CONVERSATION": "การสนทนา",
    "CSAT": "CSAT",
    "LIVE_CHAT": "Live Chat",
    "SMS": "SMS",
    "WHATSAPP": "WhatsApp",
    "CAMPAIGNS": "แคมเปญ",
    "ONGOING": "ต่อเนื่อง",
    "ONE_OFF": "ครั้งเดียว",
    "REPORTS_SLA": "SLA",
    "REPORTS_BOT": "บอท",
    "REPORTS_AGENT": "พนักงาน",
    "REPORTS_LABEL": "ป้ายกำกับ",
    "REPORTS_INBOX": "กล่องข้อความ",
    "REPORTS_TEAM": "ทีม",
    "AGENT_ASSIGNMENT": "Agent Assignment",
    "SET_AVAILABILITY_TITLE": "ตั้งสถานะเป็น...",
    "SET_YOUR_AVAILABILITY": "ตั้งค่าความพร้อมในการให้บริการ",
    "SLA": "SLA",
    "CUSTOM_ROLES": "Custom Roles",
    "BETA": "Beta",
    "REPORTS_OVERVIEW": "ภาพรวม",
    "REAUTHORIZE": "Your inbox connection has expired, please reconnect\n to continue receiving and sending messages",
    "HELP_CENTER": {
      "TITLE": "Help Center",
      "ARTICLES": "Articles",
      "CATEGORIES": "Categories",
      "LOCALES": "Locales",
      "SETTINGS": "ตั้งค่า"
    },
    "CHANNELS": "ช่อง",
    "SET_AUTO_OFFLINE": {
      "TEXT": "Mark offline automatically",
      "INFO_TEXT": "Let the system automatically mark you offline when you aren't using the app or dashboard.",
      "INFO_SHORT": "Automatically mark offline when you aren't using the app."
    },
    "SORT_TOOLTIP": "Sort",
    "SORT_BY": "เรียงด้วย",
    "SORT_GROUPS": {
      "CREATED": "Sort by date of creation",
      "ALPHABETICAL": "Sort in alphabetical order",
      "UNREAD_COUNT": "Sort by unread count"
    },
    "SORT_OPTIONS": {
      "CREATED_DESC": "Newest first",
      "CREATED_ASC": "Oldest first",
      "ALPHABETICAL_ASC": "Ascending (A - Z)",
      "ALPHABETICAL_DESC": "Descending (Z - A)",
      "UNREAD_COUNT_DESC": "Highest first",
      "UNREAD_COUNT_ASC": "Lowest first"
    },
    "DOCS": "Read docs",
    "SECURITY": "Security",
    "CAPTAIN_AI": "Captain",
    "CONVERSATION_WORKFLOW": "Conversation Workflow"
  },
  "DATA_IMPORTS": {
    "HEADER": "Data",
    "DESCRIPTION": "Bring your existing contacts and past conversations into this account from another support tool. Each import runs in the background, so you can keep working while it finishes, track its progress, and review anything that was skipped along the way.",
    "LOADING": "Fetching imports",
    "DEFAULT_IMPORT_NAME": "Intercom import",
    "TABS": {
      "IMPORT": "นำเข้า",
      "EXPORT": "Export"
    },
    "TYPES": {
      "CONTACTS": "ผู้ติดต่อ",
      "CONVERSATIONS": "การสนทนา",
      "MESSAGES": "ข้อความทั้งหมด"
    },
    "DRAWER": {
      "TITLE": "New import",
      "SOURCE": "Source",
      "NAME": "Import name",
      "NAME_PLACEHOLDER": "July Intercom migration",
      "ACCESS_KEY": "Intercom access key",
      "ACCESS_KEY_PLACEHOLDER": "Paste your Intercom access key",
      "DATA_TYPES": "Data to import",
      "VALIDATING": "Validating access key...",
      "VALID_KEY": "Access key validated.",
      "INVALID_KEY": "Could not validate this access key.",
      "ACTIVE_IMPORT": "Wait for the active import to finish before starting another one.",
      "CANCEL": "ยกเลิก",
      "IMPORT": "นำเข้า"
    },
    "EXPORT": {
      "TITLE": "Exports are on the way",
      "DESCRIPTION": "Export your contacts and conversations out of this account. This workflow is coming soon.",
      "COMING_SOON": "Coming soon"
    },
    "TABLE": {
      "TITLE": "Recent imports",
      "EMPTY": "No imports yet",
      "EMPTY_DESCRIPTION": "Start an import to bring your existing customer history into this account.",
      "NEW_IMPORT": "นำเข้า",
      "COUNT": "{count} imports",
      "UNNAMED": "Untitled import",
      "IMPORTED_COUNT": "{count} imported",
      "VIEW": "View import",
      "NAME": "ชื่อ",
      "TYPE": "ประเภท",
      "STATUS": "สถานะ",
      "IMPORTED": "Imported",
      "CREATED": "Created",
      "ABANDON": "Abandon"
    },
    "DETAIL": {
      "BACK": "Back to imports",
      "ERRORS": "Errors",
      "SKIP_LOGS": "Skip logs",
      "SOURCE": "Source",
      "IMPORT_TYPES": "Import types",
      "CREATED": "Created",
      "DURATION": "Duration",
      "INITIATED_BY": "Started by",
      "PROGRESS": "Import progress",
      "PROGRESS_WITH_TOTAL": "{imported} of {total} imported",
      "PROGRESS_WITHOUT_TOTAL": "{imported} imported",
      "PROGRESS_OF_TOTAL": "of {total} imported",
      "PROGRESS_IMPORTED": "imported",
      "LAST_UPDATED_TOOLTIP": "Last updated {time}",
      "NO_SKIP_LOGS": "No skipped or failed records recorded.",
      "DOWNLOAD_SKIP_LOGS": "Download CSV",
      "DOWNLOAD_ERROR_LOGS": "Download CSV",
      "ALL_SKIP_LOGS": "ทั้งหมด",
      "KIND": "Kind",
      "NO_ERRORS": "No errors recorded.",
      "ERROR_CODE": "Code",
      "SOURCE_OBJECT": "Source object",
      "MESSAGE": "ข้อความ"
    },
    "MONITOR": {
      "LIVE": "Live updates every {seconds}s",
      "LAST_UPDATED": "Last updated {time}",
      "REFRESH": "โหลดใหม่",
      "REFRESHING": "Refreshing",
      "STAGES": {
        "unknown": "Waiting for update",
        "queued": "Queued",
        "contacts": "Importing contacts",
        "conversations": "Importing conversations",
        "finalizing": "Finalizing import",
        "completed": "เสร็จสิ้น",
        "completed_with_errors": "Completed with errors",
        "failed": "Failed",
        "abandoned": "Abandoned"
      }
    },
    "ALERTS": {
      "IMPORT_STARTED": "Intercom import has started.",
      "IMPORT_ABANDONED": "Intercom import has been abandoned.",
      "IMPORT_FAILED": "Could not start the Intercom import."
    }
  },
  "CAPTAIN_SETTINGS": {
    "TITLE": "Captain Settings",
    "DESCRIPTION": "Configure your AI models and features for Captain. Captain follows a credit based billing, you will be charged credits for every action Captain takes based on the model selected.",
    "LOADING": "Loading Captain configuration...",
    "LINK_TEXT": "Learn more about Captain Credits",
    "NOT_ENABLED": "Captain is not enabled for your account. Please upgrade your plan to access Captain features.",
    "MODEL_CONFIG": {
      "TITLE": "Model Configuration",
      "DESCRIPTION": "Select AI models for different features.",
      "SELECT_MODEL": "Select model",
      "CREDITS_PER_MESSAGE": "{credits} credit/message",
      "COMING_SOON": "Coming soon",
      "EDITOR": {
        "TITLE": "Editor Features",
        "DESCRIPTION": "Powers smart compose, grammar corrections, tone adjustments, and content enhancement in your message editor."
      },
      "ASSISTANT": {
        "TITLE": "Assistant",
        "DESCRIPTION": "Handles automated responses, conversation summaries, and intelligent reply suggestions for customer interactions."
      },
      "COPILOT": {
        "TITLE": "Co-pilot",
        "DESCRIPTION": "Provides real-time contextual suggestions, knowledge base recommendations, and proactive insights during conversations."
      }
    },
    "FEATURES": {
      "TITLE": "ฟีเจอร์",
      "DESCRIPTION": "Enable or disable AI-powered features.",
      "AUDIO_TRANSCRIPTION": {
        "TITLE": "Audio Transcription",
        "DESCRIPTION": "Automatically convert voice messages and call recordings into searchable text transcripts.",
        "MODEL_TITLE": "Audio Transcription Model",
        "MODEL_DESCRIPTION": "Select the AI model to use for converting audio messages into text transcripts"
      },
      "HELP_CENTER_SEARCH": {
        "TITLE": "Help Center Search Indexing",
        "DESCRIPTION": "Use AI for context aware search inside your help center articles."
      },
      "LABEL_SUGGESTION": {
        "TITLE": "Label Suggestion",
        "DESCRIPTION": "Automatically suggest relevant labels and tags for conversations based on content analysis and context.",
        "MODEL_TITLE": "Label Suggestion Model",
        "MODEL_DESCRIPTION": "Select the AI model to use for analyzing conversations and suggesting appropriate labels"
      }
    },
    "API": {
      "SUCCESS": "Captain settings updated successfully.",
      "ERROR": "Failed to update Captain settings. Please try again."
    }
  },
  "BILLING_SETTINGS": {
    "TITLE": "Billing",
    "DESCRIPTION": "Manage your subscription here, upgrade your plan and get more for your team.",
    "CURRENT_PLAN": {
      "TITLE": "Current Plan",
      "PLAN_NOTE": "You are currently subscribed to the **{plan}** plan with **{quantity}** licenses",
      "SEAT_COUNT": "Number of seats",
      "RENEWS_ON": "Renews on",
      "CURRENCY": "Currency"
    },
    "CURRENCY": {
      "SELECT": {
        "TITLE": "Choose your billing currency",
        "DESCRIPTION": "Select the currency you'd like to be billed in. This can't be changed once your subscription is created."
      },
      "OPTIONS": {
        "USD": "US Dollar (USD)",
        "BRL": "Brazilian Real (BRL)"
      }
    },
    "VIEW_PRICING": "View Pricing",
    "MANAGE_SUBSCRIPTION": {
      "TITLE": "Manage your subscription",
      "DESCRIPTION": "View your previous invoices, edit your billing details, or cancel your subscription.",
      "BUTTON_TXT": "Go to the billing portal"
    },
    "CAPTAIN": {
      "TITLE": "Captain",
      "DESCRIPTION": "Manage usage and credits for Captain AI.",
      "BUTTON_TXT": "Buy more credits",
      "DOCUMENTS": "Documents",
      "RESPONSES": "Responses",
      "UPGRADE": "Captain is not available on the free plan, upgrade now to get access to assistants, copilot and more.",
      "REFRESH_CREDITS": "โหลดใหม่"
    },
    "CHAT_WITH_US": {
      "TITLE": "Need help?",
      "DESCRIPTION": "Do you face any issues in billing? We are here to help.",
      "BUTTON_TXT": "คุยกับเรา"
    },
    "NO_BILLING_USER": "Your billing account is being configured. Please refresh the page and try again.",
    "TOPUP": {
      "BUY_CREDITS": "Buy more credits",
      "MODAL_TITLE": "Buy AI Credits",
      "MODAL_DESCRIPTION": "Purchase additional credits for Captain AI.",
      "CREDITS": "CREDITS",
      "ONE_TIME": "one-time",
      "POPULAR": "Most Popular",
      "NOTE_TITLE": "Note:",
      "NOTE_DESCRIPTION": "Credits are added immediately and expire in 6 months. An active subscription is required to use credits. Purchased credits are consumed after your monthly plan credits.",
      "CANCEL": "ยกเลิก",
      "PURCHASE": "Purchase Credits",
      "LOADING": "Loading options...",
      "FETCH_ERROR": "Failed to load credit options. Please try again.",
      "RETRY": "Retry",
      "PURCHASE_ERROR": "Failed to process purchase. Please try again.",
      "PURCHASE_SUCCESS": "Successfully added {credits} credits to your account",
      "CONFIRM": {
        "TITLE": "Confirm Purchase",
        "DESCRIPTION": "You are about to purchase {credits} credits for {amount}.",
        "INSTANT_DEDUCTION_NOTE": "Your saved card will be charged immediately upon confirmation.",
        "GO_BACK": "Go Back",
        "CONFIRM_PURCHASE": "Confirm Purchase"
      }
    }
  },
  "SECURITY_SETTINGS": {
    "TITLE": "Security",
    "DESCRIPTION": "Manage your account security settings.",
    "LINK_TEXT": "Learn more about SAML SSO",
    "SAML_DISABLED_MESSAGE": "SAML SSO is currently disabled. Please contact your administrator to enable this feature.",
    "SAML": {
      "TITLE": "SAML SSO",
      "NOTE": "Configure SAML single sign-on for your account. Users will authenticate through your identity provider instead of using email/password.",
      "ACS_URL": {
        "LABEL": "ACS URL",
        "TOOLTIP": "Assertion Consumer Service URL - Configure this URL in your IdP as the destination for SAML responses"
      },
      "SSO_URL": {
        "LABEL": "SSO URL",
        "HELP": "The URL where SAML authentication requests will be sent",
        "PLACEHOLDER": "https://your-idp.com/saml/sso"
      },
      "CERTIFICATE": {
        "LABEL": "Signing certificate in PEM format",
        "HELP": "The public certificate from your identity provider used to verify SAML responses",
        "PLACEHOLDER": "-----BEGIN CERTIFICATE-----\nMIIC..."
      },
      "FINGERPRINT": {
        "LABEL": "Fingerprint",
        "TOOLTIP": "SHA-1 fingerprint of the certificate - Use this to verify the certificate in your IdP configuration"
      },
      "COPY_SUCCESS": "คัดลอกไปยังคลิปบอร์ดเเล้ว",
      "SP_ENTITY_ID": {
        "LABEL": "SP Entity ID",
        "HELP": "Unique identifier for this application as a service provider (auto-generated).",
        "TOOLTIP": "Unique identifier for Chatwoot as the Service Provider - Configure this in your IdP settings"
      },
      "IDP_ENTITY_ID": {
        "LABEL": "Identity Provider Entity ID",
        "HELP": "Unique identifier for your identity provider (usually found in IdP configuration)",
        "PLACEHOLDER": "https://your-idp.com/saml"
      },
      "UPDATE_BUTTON": "Update SAML Settings",
      "API": {
        "SUCCESS": "SAML settings updated successfully",
        "ERROR": "Failed to update SAML settings",
        "ERROR_LOADING": "Failed to load SAML settings",
        "DISABLED": "SAML settings disabled successfully"
      },
      "VALIDATION": {
        "REQUIRED_FIELDS": "SSO URL, Identity Provider Entity ID, and Certificate are required fields",
        "SSO_URL_ERROR": "Please enter a valid SSO URL",
        "CERTIFICATE_ERROR": "Certificate is required",
        "IDP_ENTITY_ID_ERROR": "Identity Provider Entity ID is required"
      },
      "ENTERPRISE_PAYWALL": {
        "AVAILABLE_ON": "The SAML SSO feature is only available in the Enterprise plans.",
        "UPGRADE_PROMPT": "Upgrade to an Enterprise plan to access SAML single sign-on and other advanced security features.",
        "ASK_ADMIN": "Please reach out to your administrator for the upgrade."
      },
      "PAYWALL": {
        "TITLE": "Upgrade to enable SAML SSO",
        "AVAILABLE_ON": "The SAML SSO feature is only available in the Enterprise plans.",
        "UPGRADE_PROMPT": "Upgrade your plan to get access to SAML single sign-on and other advanced features.",
        "UPGRADE_NOW": "Upgrade now",
        "CANCEL_ANYTIME": "You can change or cancel your plan anytime"
      },
      "ATTRIBUTE_MAPPING": {
        "TITLE": "SAML Attribute Setup",
        "DESCRIPTION": "The following attribute mappings must be configured in your identity provider"
      },
      "INFO_SECTION": {
        "TITLE": "Service Provider Information",
        "TOOLTIP": "Copy these values and configure them in your Identity Provider to establish the SAML connection"
      }
    }
  },
  "CONVERSATION_WORKFLOW": {
    "INDEX": {
      "HEADER": {
        "TITLE": "Conversation Workflows",
        "DESCRIPTION": "Configure rules and required fields for conversation resolution."
      }
    },
    "REQUIRED_ATTRIBUTES": {
      "TITLE": "Attributes required on resolution",
      "DESCRIPTION": "When resolving a conversation, agents will be prompted to fill these attributes if they haven't yet.",
      "NO_ATTRIBUTES": "No attributes added yet",
      "ADD": {
        "TITLE": "Add Attributes",
        "SEARCH_PLACEHOLDER": "ค้นหาแอตทริบิวต์"
      },
      "SAVE": {
        "SUCCESS": "Required attributes updated",
        "ERROR": "Could not update required attributes, please try again"
      },
      "MODAL": {
        "TITLE": "เสร็จสิ้นการสนทนา",
        "DESCRIPTION": "Please fill in the following custom attributes before resolving this conversation",
        "ACTIONS": {
          "RESOLVE": "เสร็จสิ้นการสนทนา",
          "CANCEL": "ยกเลิก"
        },
        "PLACEHOLDERS": {
          "TEXT": "Write a note...",
          "NUMBER": "Enter a number",
          "LINK": "Add a link",
          "DATE": "Pick a date",
          "LIST": "Select an option"
        },
        "CHECKBOX": {
          "YES": "ใช่",
          "NO": "ไม่"
        }
      },
      "PAYWALL": {
        "TITLE": "Upgrade to use required attributes",
        "AVAILABLE_ON": "The required conversation attributes feature is available on the Business and Enterprise plans.",
        "UPGRADE_PROMPT": "Upgrade your plan to prompt agents to fill required attributes before conversation resolution.",
        "UPGRADE_NOW": "Upgrade now",
        "CANCEL_ANYTIME": "You can change or cancel your plan anytime"
      },
      "ENTERPRISE_PAYWALL": {
        "AVAILABLE_ON": "The required conversation attributes feature is available on the paid plans.",
        "UPGRADE_PROMPT": "Upgrade to a paid plan to enforce required attributes before conversation resolution.",
        "ASK_ADMIN": "Please reach out to your administrator for the upgrade."
      }
    }
  },
  "CREATE_ACCOUNT": {
    "NO_ACCOUNT_WARNING": "ไม่นะ! ดูเหมือนว่าเราจะไม่เจอบัญชี Chatwoot ของคุณ โปรดสร้างบัญชีใหม่เพื่อดำเนินการต่อ",
    "NEW_ACCOUNT": "สร้างบัญชีใหม่",
    "SELECTOR_SUBTITLE": "สร้างบัญชีใหม่",
    "API": {
      "SUCCESS_MESSAGE": "สร้างบัญชีสำเร็จแล้ว",
      "EXIST_MESSAGE": "บัญชีนี้มีผู้ใช้งานแล้ว",
      "ERROR_MESSAGE": "ไม่สามารถเชื่อมต่อเซิฟเวอร์ได้โปรดลองอีกครั้งในภายหลัง"
    },
    "FORM": {
      "NAME": {
        "LABEL": "ชื่อบริษัท",
        "PLACEHOLDER": "ชื่อบริษัท"
      },
      "SUBMIT": "ส่ง",
      "CANCEL": "ยกเลิก"
    }
  },
  "KEYBOARD_SHORTCUTS": {
    "TOGGLE_MODAL": "View all shortcuts",
    "TITLE": {
      "OPEN_CONVERSATION": "เปิดดูการสนทนา",
      "RESOLVE_AND_NEXT": "จบการสนทนานี้และเริ่มการสนทนาถัดไป",
      "NAVIGATE_DROPDOWN": "เลือกรายการ",
      "RESOLVE_CONVERSATION": "เสร็จสิ้นการสนทนา",
      "GO_TO_CONVERSATION_DASHBOARD": "ไปที่หน้าการสนทนา",
      "ADD_ATTACHMENT": "เพิ่มไฟล์แนบ",
      "GO_TO_CONTACTS_DASHBOARD": "ไปที่หน้าผู้ติดต่อ",
      "TOGGLE_SIDEBAR": "เปิดหรือปิดเมนูข้าง",
      "GO_TO_REPORTS_SIDEBAR": "ไปที่แถบรายงาน",
      "MOVE_TO_NEXT_TAB": "ไปแท็บการสนทนาถัดไป",
      "GO_TO_SETTINGS": "ไปที่ตั้งค่า",
      "SWITCH_TO_PRIVATE_NOTE": "สลับเป็นโน้ตส่วนตัว",
      "SWITCH_TO_REPLY": "สลับเป็นการตอบกลับ",
      "TOGGLE_SNOOZE_DROPDOWN": "เปิดหรือปิดเมนูพักการสนทนา"
    }
  },
  "ASSIGNMENT_POLICY": {
    "INDEX": {
      "HEADER": {
        "TITLE": "Agent assignment",
        "DESCRIPTION": "Define policies to effectively manage workload and route conversations based on the needs of inboxes and agents. Learn more here"
      },
      "ASSIGNMENT_POLICY": {
        "TITLE": "Assignment policy",
        "DESCRIPTION": "Manage how conversations get assigned in inboxes.",
        "FEATURES": [
          "Assign by conversations evenly or by available capacity",
          "Add fair distribution rules to avoid overloading any agent",
          "Add inboxes to a policy - one policy per inbox"
        ]
      },
      "AGENT_CAPACITY_POLICY": {
        "TITLE": "Agent capacity policy",
        "DESCRIPTION": "Manage workload for agents.",
        "FEATURES": [
          "Define maximum conversations per inbox",
          "Create exceptions based on labels and time",
          "Add agents to a policy - one policy per agent"
        ]
      }
    },
    "AGENT_ASSIGNMENT_POLICY": {
      "INDEX": {
        "HEADER": {
          "TITLE": "Assignment policy",
          "CREATE_POLICY": "New policy"
        },
        "CARD": {
          "ORDER": "Order",
          "PRIORITY": "Priority",
          "ACTIVE": "ใช้งานอยู่",
          "INACTIVE": "Inactive",
          "POPOVER": "Added inboxes",
          "EDIT": "เเก้ไข"
        },
        "NO_RECORDS_FOUND": "No assignment policies found"
      },
      "CREATE": {
        "HEADER": {
          "TITLE": "Create assignment policy"
        },
        "CREATE_BUTTON": "Create policy",
        "API": {
          "SUCCESS_MESSAGE": "Assignment policy created successfully",
          "ERROR_MESSAGE": "Failed to create assignment policy",
          "INBOX_LINKED": "Inbox has been linked to the policy"
        }
      },
      "EDIT": {
        "HEADER": {
          "TITLE": "Edit assignment policy"
        },
        "EDIT_BUTTON": "Update policy",
        "CONFIRM_ADD_INBOX_DIALOG": {
          "TITLE": "Add inbox",
          "DESCRIPTION": "{inboxName} inbox is already linked to another policy. Are you sure you want to link it to this policy? It will be unlinked from the other policy.",
          "CONFIRM_BUTTON_LABEL": "Continue",
          "CANCEL_BUTTON_LABEL": "ยกเลิก"
        },
        "INBOX_LINK_PROMPT": {
          "TITLE": "Link inbox to policy",
          "DESCRIPTION": "Would you like to link this inbox to the assignment policy?",
          "LINK_BUTTON": "Link inbox",
          "CANCEL_BUTTON": "Skip"
        },
        "API": {
          "SUCCESS_MESSAGE": "Assignment policy updated successfully",
          "ERROR_MESSAGE": "Failed to update assignment policy"
        },
        "INBOX_API": {
          "ADD": {
            "SUCCESS_MESSAGE": "Inbox added to policy successfully",
            "ERROR_MESSAGE": "Failed to add inbox to policy"
          },
          "REMOVE": {
            "SUCCESS_MESSAGE": "Inbox removed from policy successfully",
            "ERROR_MESSAGE": "Failed to remove inbox from policy"
          }
        }
      },
      "FORM": {
        "NAME": {
          "LABEL": "Policy name:",
          "PLACEHOLDER": "Enter policy name"
        },
        "DESCRIPTION": {
          "LABEL": "คำอธิบาย:",
          "PLACEHOLDER": "Enter description"
        },
        "STATUS": {
          "LABEL": "สถานะ:",
          "PLACEHOLDER": "Select status",
          "ACTIVE": "Policy is active",
          "INACTIVE": "Policy is inactive"
        },
        "ASSIGNMENT_ORDER": {
          "LABEL": "Assignment order",
          "ROUND_ROBIN": {
            "LABEL": "Round robin",
            "DESCRIPTION": "Assign conversations evenly among agents."
          },
          "BALANCED": {
            "LABEL": "Balanced",
            "DESCRIPTION": "Assign conversations based on available capacity.",
            "PREMIUM_MESSAGE": "Upgrade to access balanced assignment and agent capacity management.",
            "PREMIUM_BADGE": "Premium"
          }
        },
        "ASSIGNMENT_PRIORITY": {
          "LABEL": "Assignment priority",
          "EARLIEST_CREATED": {
            "LABEL": "Earliest created",
            "DESCRIPTION": "The conversation that was created first gets assigned first."
          },
          "LONGEST_WAITING": {
            "LABEL": "Longest waiting",
            "DESCRIPTION": "The conversation waiting the longest gets assigned first."
          }
        },
        "FAIR_DISTRIBUTION": {
          "LABEL": "Fair distribution policy",
          "DESCRIPTION": "Set the maximum number of conversations that can be assigned per agent within a time window to avoid overloading any one agent. This required field defaults to 100 conversations per hour.",
          "INPUT_MAX": "Assign max",
          "DURATION": "Conversations per agent in every"
        },
        "EXCLUDE_OLDER_THAN": {
          "LABEL": "Skip stale conversations",
          "DESCRIPTION": "Skip unassigned conversations older than this. Defaults to 7 days; clear to disable."
        },
        "INBOXES": {
          "LABEL": "Added inboxes",
          "DESCRIPTION": "Add inboxes for which this policy will be applicable.",
          "ADD_BUTTON": "Add inbox",
          "DROPDOWN": {
            "SEARCH_PLACEHOLDER": "Search and select inboxes to add",
            "ADD_BUTTON": "เพิ่ม"
          },
          "EMPTY_STATE": "No inboxes added to this policy, add an inbox to get started",
          "API": {
            "SUCCESS_MESSAGE": "Inbox successfully added to policy",
            "ERROR_MESSAGE": "Failed to add inbox to policy"
          }
        }
      },
      "DELETE_POLICY": {
        "SUCCESS_MESSAGE": "Assignment policy deleted successfully",
        "ERROR_MESSAGE": "Failed to delete assignment policy"
      }
    },
    "AGENT_CAPACITY_POLICY": {
      "INDEX": {
        "HEADER": {
          "TITLE": "Agent capacity",
          "CREATE_POLICY": "New policy"
        },
        "CARD": {
          "POPOVER": "Added agents",
          "EDIT": "เเก้ไข"
        },
        "NO_RECORDS_FOUND": "No agent capacity policies found"
      },
      "CREATE": {
        "HEADER": {
          "TITLE": "Create agent capacity policy"
        },
        "CREATE_BUTTON": "Create policy",
        "API": {
          "SUCCESS_MESSAGE": "Agent capacity policy created successfully",
          "ERROR_MESSAGE": "Failed to create agent capacity policy"
        }
      },
      "EDIT": {
        "HEADER": {
          "TITLE": "Edit agent capacity policy"
        },
        "EDIT_BUTTON": "Update policy",
        "CONFIRM_ADD_AGENT_DIALOG": {
          "TITLE": "Add agent",
          "DESCRIPTION": "{agentName} is already linked to another policy. Are you sure you want to link it to this policy? It will be unlinked from the other policy.",
          "CONFIRM_BUTTON_LABEL": "Continue",
          "CANCEL_BUTTON_LABEL": "ยกเลิก"
        },
        "API": {
          "SUCCESS_MESSAGE": "Agent capacity policy updated successfully",
          "ERROR_MESSAGE": "Failed to update agent capacity policy"
        },
        "AGENT_API": {
          "ADD": {
            "SUCCESS_MESSAGE": "Agent added to policy successfully",
            "ERROR_MESSAGE": "Failed to add agent to policy"
          },
          "REMOVE": {
            "SUCCESS_MESSAGE": "Agent removed from policy successfully",
            "ERROR_MESSAGE": "Failed to remove agent from policy"
          }
        },
        "INBOX_LIMIT_API": {
          "ADD": {
            "SUCCESS_MESSAGE": "Inbox limit added successfully",
            "ERROR_MESSAGE": "Failed to add inbox limit"
          },
          "UPDATE": {
            "SUCCESS_MESSAGE": "Inbox limit updated successfully",
            "ERROR_MESSAGE": "Failed to update inbox limit"
          },
          "DELETE": {
            "SUCCESS_MESSAGE": "Inbox limit deleted successfully",
            "ERROR_MESSAGE": "Failed to delete inbox limit"
          }
        }
      },
      "FORM": {
        "NAME": {
          "LABEL": "Policy name:",
          "PLACEHOLDER": "Enter policy name"
        },
        "DESCRIPTION": {
          "LABEL": "คำอธิบาย:",
          "PLACEHOLDER": "Enter description"
        },
        "INBOX_CAPACITY_LIMIT": {
          "LABEL": "Inbox capacity limits",
          "ADD_BUTTON": "Add inbox",
          "FIELD": {
            "SELECT_INBOX": "Select inbox",
            "MAX_CONVERSATIONS": "Max conversations",
            "SET_LIMIT": "Set limit"
          },
          "EMPTY_STATE": "No inbox limit set"
        },
        "EXCLUSION_RULES": {
          "LABEL": "Exclusion rules",
          "DESCRIPTION": "Conversations that satisfy the following conditions would not count towards agent capacity",
          "TAGS": {
            "LABEL": "Exclude conversations tagged with specific labels",
            "ADD_TAG": "add tag",
            "DROPDOWN": {
              "SEARCH_PLACEHOLDER": "Search and select tags to add"
            },
            "EMPTY_STATE": "No tags added to this policy."
          },
          "DURATION": {
            "LABEL": "Exclude conversations older than a specified duration",
            "PLACEHOLDER": "Set time"
          }
        },
        "USERS": {
          "LABEL": "Assigned agents",
          "DESCRIPTION": "Add agents for which this policy will be applicable.",
          "ADD_BUTTON": "Add agent",
          "DROPDOWN": {
            "SEARCH_PLACEHOLDER": "Search and select agents to add",
            "ADD_BUTTON": "เพิ่ม"
          },
          "EMPTY_STATE": "No agents added",
          "API": {
            "SUCCESS_MESSAGE": "Agent successfully added to policy",
            "ERROR_MESSAGE": "Failed to add agent to policy"
          }
        }
      },
      "DELETE_POLICY": {
        "SUCCESS_MESSAGE": "Agent capacity policy deleted successfully",
        "ERROR_MESSAGE": "Failed to delete agent capacity policy"
      }
    },
    "DELETE_POLICY": {
      "TITLE": "Delete policy",
      "DESCRIPTION": "Are you sure you want to delete this policy? This action cannot be undone.",
      "CONFIRM_BUTTON_LABEL": "ลบ",
      "CANCEL_BUTTON_LABEL": "ยกเลิก"
    }
  }
}
